import React from "react";
import { Input, Form } from "antd";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./Input.module.scss";
import ViewField from "../ViewField";

const CustomizeInput = React.forwardRef(({
    width,
    label,
    classLabel,
    classInput,
    mandatory = true,
    type,
    mode = "editable",
    ...rest
}, ref) => {
    const noteLabel = label => {
        return (
            <span>
                <span style={{ color: "red" }}>* </span>
                {label + ": "}
            </span>
        );
    };

    return (
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "5px" }}>
            <div className={cx(styles.FormItem, classLabel)} style={{ fontWeight: "600", fontSize: "13px", color: "#000000d9", width: "178px" }}>{mandatory ? noteLabel(label) : label + ": "}</div>
            <Input
                ref={ref}
                style={{ width: width || "100%" }}
                className={cx(styles[type], styles.Input, classInput)}
                {...rest}
            />
        </div>
    );
});

CustomizeInput.propTypes = {
    width: PropTypes.string,
    mandatory: PropTypes.bool
};


export default CustomizeInput